import auth from "./routes/auth";

export default [
    {
        path: "/",
        name: "default",
        meta: {authRequired: true},
        component: () => import("./views/index")
    },
    {
        path: "/dashboard",
        name: "dashboard.show",
        meta: {authRequired: true, permission: "dashboards.view"},
        component: () => import("./views/dashboards/show")
    },
    {
        path: "/projections",
        name: "projections.show",
        meta: {authRequired: true, permission: "dashboards.view"},
        component: () => import("./views/projections/show")
    },
    ...auth,
    {
        path: "/404",
        name: "404",
        component: require("./views/utility/404").default
    },
    {
        path: "/403",
        name: "403",
        component: require("./views/utility/403").default
    },
    {
        path: "/deactivated",
        name: "deactivated",
        component: require("./views/utility/deactivated").default
    },
    // Redirect any unmatched routes to the 404 page. This may
    // require some server configuration to work in production:
    // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
    {
        path: "*",
        redirect: "404"
    },

    // {
    //   path: "/models",
    //   name: "models.index",
    //   meta: { authRequired: true },
    //   component: () => import("./views/models")
    // },
    // {
    //   path: "/models/create",
    //   name: "models.create",
    //   meta: { authRequired: true },
    //   component: () => import("./views/models/create")
    // },
    // {
    //   path: "/models/:key",
    //   name: "models.show",
    //   meta: { authRequired: true },
    //   component: () => import("./views/models/show")
    // },
    // {
    //   path: "/models/:key/edit",
    //   name: "models.edit",
    //   meta: { authRequired: true },
    //   component: () => import("./views/models/edit")
    // },

    // {
    //   path: "/dashboard/saas",
    //   name: "saas-dashboard",
    //   meta: { authRequired: true },
    //   component: () => import("./views/dashboards/saas/index")
    // },
    // {
    //   path: "/dashboard/crypto",
    //   name: "crypto-dashboard",
    //   meta: { authRequired: true },
    //   component: () => import("./views/dashboards/crypto/index")
    // },
    // {
    //   path: "/dashboard/blog",
    //   name: "blog-dashboard",
    //   meta: { authRequired: true },
    //   component: () => import("./views/dashboards/blog/index")
    // },
    // {
    //   path: "/calendar",
    //   name: "Calendar",
    //   meta: { authRequired: true },
    //   component: () => import("./views/calendar/calendar")
    // },
    // {
    //   path: "/chat",
    //   name: "chat",
    //   meta: { authRequired: true },
    //   component: () => import("./views/chat/index")
    // },
    // {
    //   path: "/apps/file-manager",
    //   name: "file-manager",
    //   meta: { authRequired: true },
    //   component: () => import("./views/file-manager/index")
    // },
    // {
    //   path: "/ecommerce/products",
    //   name: "Products",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/products")
    // },
    // {
    //   path: "/ecommerce/product-detail/:id",
    //   name: "Product Detail",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/product-detail")
    // },
    // {
    //   path: "/ecommerce/orders",
    //   name: "Orders",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/orders")
    // },
    // {
    //   path: "/ecommerce/customers",
    //   name: "Customers",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/customers")
    // },
    // {
    //   path: "/ecommerce/cart",
    //   name: "Cart",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/cart")
    // },
    // {
    //   path: "/ecommerce/checkout",
    //   name: "Checkout",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/checkout")
    // },
    // {
    //   path: "/ecommerce/shops",
    //   name: "Shops",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/shops")
    // },
    // {
    //   path: "/ecommerce/add-product",
    //   name: "Add Product",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ecommerce/add-product")
    // },
    // {
    //   path: "/blog/list",
    //   name: "blog-list",
    //   meta: { authRequired: true },
    //   component: () => import("./views/blog/list")
    // },
    // {
    //   path: "/blog/grid",
    //   name: "blog-grid",
    //   meta: { authRequired: true },
    //   component: () => import("./views/blog/grid")
    // },
    // {
    //   path: "/blog/detail",
    //   name: "blog-detail",
    //   meta: { authRequired: true },
    //   component: () => import("./views/blog/detail")
    // },
    // {
    //   path: "/crypto/wallet",
    //   name: "Wallet",
    //   meta: { authRequired: true },
    //   component: () => import("./views/crypto/wallet/index")
    // },
    // {
    //   path: "/crypto/buy-sell",
    //   name: "Buy/sell",
    //   meta: { authRequired: true },
    //   component: () => import("./views/crypto/buysell/index")
    // },
    // {
    //   path: "/crypto/exchange",
    //   name: "Exchange",
    //   meta: { authRequired: true },
    //   component: () => import("./views/crypto/exchange/index")
    // },
    // {
    //   path: "/crypto/lending",
    //   name: "Lending",
    //   meta: { authRequired: true },
    //   component: () => import("./views/crypto/lending/index")
    // },
    // {
    //   path: "/crypto/orders",
    //   name: "crypto-orders",
    //   meta: { authRequired: true },
    //   component: () => import("./views/crypto/orders/index")
    // },
    // {
    //   path: "/crypto/kyc-application",
    //   name: "kyc-application",
    //   meta: { authRequired: true },
    //   component: () => import("./views/crypto/kycapplication/index")
    // },
    // {
    //   path: "/crypto/ico-landing",
    //   name: "Ico-landing",
    //   meta: { authRequired: true },
    //   component: () => import("./views/crypto/ico-landing")
    // },
    // {
    //   path: "/invoices/detail",
    //   name: "Invoice Detail",
    //   meta: { authRequired: true },
    //   component: () => import("./views/invoices/detail")
    // },
    // {
    //   path: "/invoices/list",
    //   name: "Invoice List",
    //   meta: { authRequired: true },
    //   component: () => import("./views/invoices/list")
    // },
    // {
    //   path: "/ui/alerts",
    //   name: "Alerts",
    //   meta: {
    //     authRequired: true
    //   },
    //   component: () => import("./views/ui/alerts")
    // },
    // {
    //   path: "/ui/buttons",
    //   name: "Buttons",
    //   meta: {
    //     authRequired: true
    //   },
    //   component: () => import("./views/ui/buttons")
    // },
    // {
    //   path: "/ui/cards",
    //   name: "Cards",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/cards")
    // },
    // {
    //   path: "/ui/carousel",
    //   name: "Carousel",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/carousel")
    // },
    // {
    //   path: "/ui/dropdowns",
    //   name: "Dropdowns",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/dropdowns")
    // },
    // {
    //   path: "/ui/grid",
    //   name: "Grid",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/grid")
    // },
    // {
    //   path: "/ui/images",
    //   name: "Images",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/images")
    // },
    // {
    //   path: "/ui/modals",
    //   name: "Modals",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/modals")
    // },
    // {
    //   path: "/ui/rangeslider",
    //   name: "Rangeslider",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/rangeslider")
    // },
    // {
    //   path: "/ui/progressbars",
    //   name: "Progressbars",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/progressbars")
    // },
    // {
    //   path: "/ui/sweet-alert",
    //   name: "Sweet-alert",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/sweet-alert")
    // },
    // {
    //   path: "/ui/tabs-accordions",
    //   name: "Tabs-accordions",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/tabs-accordions")
    // },
    // {
    //   path: "/ui/typography",
    //   name: "Typography",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/typography")
    // },
    // {
    //   path: "/ui/video",
    //   name: "Video",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/video")
    // },
    // {
    //   path: "/ui/general",
    //   name: "General",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/general")
    // },
    // {
    //   path: "/ui/colors",
    //   name: "Colors",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/colors")
    // },
    // {
    //   path: "/ui/lightbox",
    //   name: "Lightbox",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/lightbox")
    // },
    // {
    //   path: "/ui/image-cropper",
    //   name: "Image Cropper",
    //   meta: { authRequired: true },
    //   component: () => import("./views/ui/cropper")
    // },
    // {
    //   path: "/projects/grid",
    //   name: "Projects Grid",
    //   meta: { authRequired: true },
    //   component: () => import("./views/projects/projects-grid")
    // },
    // {
    //   path: "/projects/list",
    //   name: "Projects List",
    //   meta: { authRequired: true },
    //   component: () => import("./views/projects/projects-list")
    // },
    // {
    //   path: "/projects/overview",
    //   name: "Project Overview",
    //   meta: { authRequired: true },
    //   component: () => import("./views/projects/overview")
    // },
    // {
    //   path: "/projects/create",
    //   name: "Create New",
    //   meta: { authRequired: true },
    //   component: () => import("./views/projects/create")
    // },
    // {
    //   path: "/contacts/grid",
    //   name: "User Grid",
    //   meta: { authRequired: true },
    //   component: () => import("./views/contacts/contacts-grid")
    // },
    // {
    //   path: "/contacts/list",
    //   name: "User List",
    //   meta: { authRequired: true },
    //   component: () => import("./views/contacts/contacts-list")
    // },
    // {
    //   path: "/contacts/profile",
    //   name: "Profile",
    //   meta: { authRequired: true },
    //   component: () => import("./views/contacts/contacts-profile")
    // },
    // {
    //   path: "/charts/apex",
    //   name: "Apex chart",
    //   meta: { authRequired: true },
    //   component: () => import("./views/charts/apex")
    // },
    // {
    //   path: "/charts/chartjs",
    //   name: "Chartjs chart",
    //   meta: { authRequired: true },
    //   component: () => import("./views/charts/chartjs/index")
    // },
    // {
    //   path: "/charts/chartist",
    //   name: "Chartist chart",
    //   meta: { authRequired: true },
    //   component: () => import("./views/charts/chartist")
    // },
    // {
    //   path: "/charts/echart",
    //   name: "Echart chart",
    //   meta: { authRequired: true },
    //   component: () => import("./views/charts/echart/index")
    // },
    // {
    //   path: "/icons/boxicons",
    //   name: "Boxicons Icon",
    //   meta: { authRequired: true },
    //   component: () => import("./views/icons/boxicons")
    // },
    // {
    //   path: "/icons/materialdesign",
    //   name: "Materialdesign Icon",
    //   meta: { authRequired: true },
    //   component: () => import("./views/icons/materialdesign")
    // },
    // {
    //   path: "/icons/dripicons",
    //   name: "Dripicons Icon",
    //   meta: { authRequired: true },
    //   component: () => import("./views/icons/dripicons")
    // },
    // {
    //   path: "/icons/fontawesome",
    //   name: "Fontawesome Icon",
    //   meta: { authRequired: true },
    //   component: () => import("./views/icons/fontawesome")
    // },
    // {
    //   path: "/maps/google",
    //   name: "Google Maps",
    //   meta: { authRequired: true },
    //   component: () => import("./views/maps/google")
    // },
    // {
    //   path: "/maps/leaflet",
    //   name: "Leaflet Maps",
    //   meta: { authRequired: true },
    //   component: () => import("./views/maps/leaflet/index")
    // },
    // {
    //   path: "/tables/basic",
    //   name: "Basic Tables",
    //   meta: { authRequired: true },
    //   component: () => import("./views/tables/basictable")
    // },
    // {
    //   path: "/tables/advanced",
    //   name: "Advanced Tables",
    //   meta: { authRequired: true },
    //   component: () => import("./views/tables/advancedtable")
    // },
    // {
    //   path: "/form/advanced",
    //   name: "Form Advanced",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/advanced")
    // },
    // {
    //   path: "/form/elements",
    //   name: "Form Elements",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/elements")
    // },
    // {
    //   path: "/form/layouts",
    //   name: "Form Layouts",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/layouts")
    // },
    // {
    //   path: "/form/editor",
    //   name: "Form Editors",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/editors")
    // },
    // {
    //   path: "/form/uploads",
    //   name: "File Uploads",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/uploads")
    // },
    // {
    //   path: "/form/validation",
    //   name: "Form Validation",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/validation")
    // },
    // {
    //   path: "/form/wizard",
    //   name: "Form Wizard",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/wizard")
    // },
    // {
    //   path: "/form/repeater",
    //   name: "Form Repeater",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/repeater")
    // },
    // {
    //   path: "/form/mask",
    //   name: "Form Mask",
    //   meta: { authRequired: true },
    //   component: () => import("./views/forms/mask")
    // },
    // {
    //   path: "/pages/starter",
    //   name: "Starter",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/starter")
    // },
    // {
    //   path: "/pages/maintenance",
    //   name: "Maintenance",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/maintenance")
    // },
    // {
    //   path: "/pages/coming-soon",
    //   name: "coming-soon",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/coming-soon")
    // },
    // {
    //   path: "/pages/timeline",
    //   name: "Timeline",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/timeline")
    // },
    // {
    //   path: "/pages/faqs",
    //   name: "FAQs",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/faqs")
    // },
    // {
    //   path: "/pages/pricing",
    //   name: "Pricing",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/pricing")
    // },
    // {
    //   path: "/pages/404",
    //   name: "Error-404",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/404")
    // },
    // {
    //   path: "/pages/500",
    //   name: "Error-500",
    //   meta: { authRequired: true },
    //   component: () => import("./views/utility/500")
    // },
    // {
    //   path: "/email/inbox",
    //   name: "Inbox",
    //   meta: { authRequired: true },
    //   component: () => import("./views/email/inbox")
    // },
    // {
    //   path: "/email/reademail/:id",
    //   name: "Read Email",
    //   meta: { authRequired: true },
    //   component: () => import("./views/email/reademail")
    // },
    // {
    //   path: "/email/templates/basic",
    //   name: "Email template basic",
    //   meta: { authRequired: true },
    //   component: () => import("./views/email/templates/basic")
    // },
    // {
    //   path: "/email/templates/billing",
    //   name: "Email template billing",
    //   meta: { authRequired: true },
    //   component: () => import("./views/email/templates/billing")
    // },
    // {
    //   path: "/email/templates/alert",
    //   name: "Email template alert",
    //   meta: { authRequired: true },
    //   component: () => import("./views/email/templates/alert")
    // },
    // {
    //   path: "/tasks/list",
    //   name: "Task list",
    //   meta: { authRequired: true },
    //   component: () => import("./views/tasks/task-list")
    // },
    // {
    //   path: "/tasks/kanban",
    //   name: "Kanbanboard",
    //   meta: { authRequired: true },
    //   component: () => import("./views/tasks/kanbanboard")
    // },
    {
        path: "/companies",
        name: "companies.index",
        meta: {authRequired: true},
        component: () => import("./views/companies")
    },
    {
        path: "/companies/create",
        name: "companies.create",
        meta: {authRequired: true},
        component: () => import("./views/companies/create")
    },
    {
        path: "/companies/:key",
        name: "companies.show",
        meta: {authRequired: true},
        component: () => import("./views/companies/show")
    },
    {
        path: "/companies/:key/edit",
        name: "companies.edit",
        meta: {authRequired: true},
        component: () => import("./views/companies/edit")
    },
    {
        path: "/customers",
        name: "customers.index",
        meta: {authRequired: true, permission: "customers.view"},
        component: () => import("./views/customers")
    },
    {
        path: "/customers/create",
        name: "customers.create",
        meta: {authRequired: true, permission: "customers.create"},
        component: () => import("./views/customers/create")
    },
    {
        path: "/customers/:key",
        name: "customers.show",
        meta: {authRequired: true, permission: "customers.view"},
        component: () => import("./views/customers/show")
    },
    {
        path: "/customers/:key/edit",
        name: "customers.edit",
        meta: {authRequired: true, permission: "customers.edit"},
        component: () => import("./views/customers/edit")
    },
    {
        path: "/bank_accounts",
        name: "bank_accounts.index",
        meta: {authRequired: true},
        component: () => import("./views/bank_accounts")
    },
    {
        path: "/bank_accounts/create",
        name: "bank_accounts.create",
        meta: {authRequired: true},
        component: () => import("./views/bank_accounts/create")
    },
    {
        path: "/bank_accounts/:key",
        name: "bank_accounts.show",
        meta: {authRequired: true},
        component: () => import("./views/bank_accounts/show")
    },
    {
        path: "/bank_accounts/:key/edit",
        name: "bank_accounts.edit",
        meta: {authRequired: true},
        component: () => import("./views/bank_accounts/edit")
    },
    {
        path: "/vehicles",
        name: "vehicles.index",
        meta: {authRequired: true, permission: "vehicles.view"},
        component: () => import("./views/vehicles")
    },
    {
        path: "/vehicles/create",
        name: "vehicles.create",
        meta: {authRequired: true, permission: "vehicles.create"},
        component: () => import("./views/vehicles/create")
    },
    {
        path: "/vehicles/:key",
        name: "vehicles.show",
        meta: {authRequired: true, permission: "vehicles.view"},
        component: () => import("./views/vehicles/show")
    },
    {
        path: "/vehicles/:key/edit",
        name: "vehicles.edit",
        meta: {authRequired: true, permission: "vehicles.edit"},
        component: () => import("./views/vehicles/edit")
    },

    {
        path: "/trips",
        name: "trips.index",
        meta: {authRequired: true, permission: "trips.view"},
        component: () => import("./views/trips")
    },
    {
        path: "/trips/create",
        name: "trips.create",
        meta: {authRequired: true, permission: "trips.create"},
        component: () => import("./views/trips/create")
    },
    {
        path: "/trips/:key",
        name: "trips.show",
        meta: {authRequired: true, permission: "trips.view"},
        component: () => import("./views/trips/show-v2")
    },
    {
        path: "/trips/:key/edit",
        name: "trips.edit",
        meta: {authRequired: true, permission: "trips.edit"},
        component: () => import("./views/trips/edit")
    },
    // {
    //   path: "/delivery_orders",
    //   name: "delivery_orders.index",
    //   meta: { authRequired: true },
    //   component: () => import("./views/delivery_orders")
    // },
    // {
    //   path: "/delivery_orders/create",
    //   name: "delivery_orders.create",
    //   meta: { authRequired: true },
    //   component: () => import("./views/delivery_orders/create")
    // },
    // {
    //   path: "/delivery_orders/:key",
    //   name: "delivery_orders.show",
    //   meta: { authRequired: true },
    //   component: () => import("./views/delivery_orders/show")
    // },
    // {
    //   path: "/delivery_orders/:key/edit",
    //   name: "delivery_orders.edit",
    //   meta: { authRequired: true },
    //   component: () => import("./views/delivery_orders/edit")
    // },

    {
        path: "/harvests",
        name: "harvests.index",
        meta: {authRequired: true},
        component: () => import("./views/harvests")
    },
    {
        path: "/harvests/create",
        name: "harvests.create",
        meta: {authRequired: true},
        component: () => import("./views/harvests/create")
    },
    {
        path: "/harvests/:key",
        name: "harvests.show",
        meta: {authRequired: true},
        component: () => import("./views/harvests/show")
    },
    {
        path: "/harvests/:key/edit",
        name: "harvests.edit",
        meta: {authRequired: true},
        component: () => import("./views/harvests/edit")
    },

    {
        path: "/receipt_orders",
        name: "receipt_orders.index",
        meta: {authRequired: true},
        component: () => import("./views/receipt_orders")
    },
    {
        path: "/receipt_orders/create",
        name: "receipt_orders.create",
        meta: {authRequired: true},
        component: () => import("./views/receipt_orders/create")
    },
    {
        path: "/receipt_orders/:key",
        name: "receipt_orders.show",
        meta: {authRequired: true},
        component: () => import("./views/receipt_orders/show")
    },
    {
        path: "/receipt_orders/:key/edit",
        name: "receipt_orders.edit",
        meta: {authRequired: true},
        component: () => import("./views/receipt_orders/edit")
    },

    {
        path: "/jala_investor_users",
        name: "jala_investor_users.index",
        meta: {authRequired: true},
        component: () => import("./views/jala_investor_users")
    },
    {
        path: "/jala_investor_users/create",
        name: "jala_investor_users.create",
        meta: {authRequired: true},
        component: () => import("./views/jala_investor_users/create")
    },
    {
        path: "/jala_investor_users/:key",
        name: "jala_investor_users.show",
        meta: {authRequired: true},
        component: () => import("./views/jala_investor_users/show")
    },
    {
        path: "/jala_investor_users/:key/edit",
        name: "jala_investor_users.edit",
        meta: {authRequired: true},
        component: () => import("./views/jala_investor_users/edit")
    },

    {
        path: "/jala_farms",
        name: "jala_farms.index",
        meta: {authRequired: true},
        component: () => import("./views/jala_farms")
    },
    {
        path: "/jala_farms/create",
        name: "jala_farms.create",
        meta: {authRequired: true},
        component: () => import("./views/jala_farms/create")
    },
    {
        path: "/jala_farms/:key",
        name: "jala_farms.show",
        meta: {authRequired: true},
        component: () => import("./views/jala_farms/show")
    },
    {
        path: "/jala_farms/:key/edit",
        name: "jala_farms.edit",
        meta: {authRequired: true},
        component: () => import("./views/jala_farms/edit")
    },

    {
        path: "/jala_ponds",
        name: "jala_ponds.index",
        meta: {authRequired: true},
        component: () => import("./views/jala_ponds")
    },
    {
        path: "/jala_ponds/create",
        name: "jala_ponds.create",
        meta: {authRequired: true},
        component: () => import("./views/jala_ponds/create")
    },
    {
        path: "/jala_ponds/:key",
        name: "jala_ponds.show",
        meta: {authRequired: true},
        component: () => import("./views/jala_ponds/show")
    },
    {
        path: "/jala_ponds/:key/edit",
        name: "jala_ponds.edit",
        meta: {authRequired: true},
        component: () => import("./views/jala_ponds/edit")
    },

    {
        path: "/jala_cycles",
        name: "jala_cycles.index",
        meta: {authRequired: true},
        component: () => import("./views/jala_cycles")
    },
    {
        path: "/jala_cycles/create",
        name: "jala_cycles.create",
        meta: {authRequired: true},
        component: () => import("./views/jala_cycles/create")
    },
    {
        path: "/jala_cycles/:key",
        name: "jala_cycles.show",
        meta: {authRequired: true},
        component: () => import("./views/jala_cycles/show")
    },
    {
        path: "/jala_cycles/:key/edit",
        name: "jala_cycles.edit",
        meta: {authRequired: true},
        component: () => import("./views/jala_cycles/edit")
    },

    {
        path: "/jala_harvests",
        name: "jala_harvests.index",
        meta: {authRequired: true},
        component: () => import("./views/jala_harvests")
    },
    {
        path: "/jala_harvests/create",
        name: "jala_harvests.create",
        meta: {authRequired: true},
        component: () => import("./views/jala_harvests/create")
    },
    {
        path: "/jala_harvests/:key",
        name: "jala_harvests.show",
        meta: {authRequired: true},
        component: () => import("./views/jala_harvests/show")
    },
    {
        path: "/jala_harvests/:key/edit",
        name: "jala_harvests.edit",
        meta: {authRequired: true},
        component: () => import("./views/jala_harvests/edit")
    },
    // Tickets Route
    {
        path: "/tickets",
        name: "tickets.index",
        meta: {authRequired: true, permission: "tickets.view"},
        component: () => import("./views/tickets/index-v2")
    },
    {
        path: "/tickets/create",
        name: "tickets.create",
        meta: {authRequired: true, permission: "tickets.create"},
        component: () => import("./views/tickets/create")
    },
    {
        path: "/tickets/:key",
        name: "tickets.show",
        meta: {authRequired: true, permission: "tickets.view"},
        component: () => import("./views/tickets/show")
    },
    {
        path: "/tickets/:key/edit",
        name: "tickets.edit",
        meta: {authRequired: true, permission: "tickets.edit"},
        component: () => import("./views/tickets/edit")
    },
    // Purchase Order Route
    {
        path: "/purchase_orders",
        name: "purchase_orders.index",
        meta: {authRequired: true, permission: "purchase_orders.view"},
        component: () => import("./views/purchase_orders")
    },
    {
        path: "/purchase_orders/create",
        name: "purchase_orders.create",
        meta: {authRequired: true, permission: "purchase_orders.create"},
        component: () => import("./views/purchase_orders/create-bulk")
        // component: () => import('./views/purchase_orders/create'),
    },
    {
        path: "/purchase_orders/:key",
        name: "purchase_orders.show",
        meta: {authRequired: true, permission: "purchase_orders.view"},
        component: () => import("./views/purchase_orders/show")
    },
    {
        path: "/purchase_orders/:key/edit",
        name: "purchase_orders.edit",
        meta: {authRequired: true, permission: "purchase_orders.edit"},
        component: () => import("./views/purchase_orders/edit")
    },
    {
        path: "/purchase_payments",
        name: "purchase_payments.index",
        meta: {authRequired: true, permission: "purchase_invoices.view"},
        component: () => import("./views/purchase_payments")
    },
    {
        path: "/purchase_payments/:key",
        name: "purchase_payments.show",
        meta: {authRequired: true, permission: "purchase_invoices.view"},
        component: () => import("./views/purchase_payments/show")
    },
    {
        path: "/sale_invoices",
        name: "sale_invoices.index",
        meta: {authRequired: true, permission: "sale_invoices.view"},
        component: () => import("./views/sale_invoices")
    },
    {
        path: "/sale_invoices/:key",
        name: "sale_invoices.show",
        meta: {authRequired: true, permission: "sale_invoices.view"},
        component: () => import("./views/sale_invoices/show")
    },
    {
        path: "/drivers",
        name: "drivers.index",
        meta: {authRequired: true, permission: "drivers.view"},
        component: () => import("./views/drivers")
    },
    {
        path: "/drivers/create",
        name: "drivers.create",
        meta: {authRequired: true, permission: "drivers.create"},
        component: () => import("./views/drivers/create")
    },
    {
        path: "/drivers/:key",
        name: "drivers.show",
        meta: {authRequired: true, permission: "drivers.view"},
        component: () => import("./views/drivers/show")
    },
    {
        path: "/drivers/:key/edit",
        name: "drivers.edit",
        meta: {authRequired: true, permission: "drivers.edit"},
        component: () => import("./views/drivers/edit")
    },
    {
        path: "/sale_notes",
        name: "sale_notes.index",
        meta: {authRequired: true, permission: "sale_reports.view"},
        component: () => import("./views/sale_notes")
    },
    {
        path: "/sale_notes/:key",
        name: "sale_notes.show",
        meta: {authRequired: true, permission: "sale_reports.view"},
        component: () => import("./views/sale_notes/show")
    },
    // {
    //     path: "/sale_notes/:key/edit",
    //     name: "sale_notes.edit",
    //     meta: {authRequired: true, permission: "sale_reports.edit"},
    //     component: () => import("./views/sale_notes/edit")
    // },
    {
        path: "/unloads",
        name: "unload.index",
        meta: {authRequired: true, permission: "sale_order.view"},
        component: () => import("./views/unload")
    },
    {
        path: "/unloads/create",
        name: "unload.create",
        meta: {authRequired: true, permission: "sale_order.create"},
        component: () => import("./views/unload/create")
    },
    {
        path: "/unloads/:key",
        name: "unload.show",
        meta: {authRequired: true, permission: "sale_order.view"},
        component: () => import("./views/unload/show-v2")
    },
    {
        path: "/unloads/:key/edit",
        name: "unload.edit",
        meta: {authRequired: true, permission: "sale_order.edit"},
        component: () => import("./views/unload/edit")
    },
    {
        path: "/weight_notes/create",
        name: "weight_notes.create",
        meta: {authRequired: true, permission: "sale_order.create"},
        component: () => import("./views/weight_notes/create")
    },
    {
        path: "/weight_notes/:key/edit",
        name: "weight_notes.edit",
        meta: {authRequired: true, permission: "sale_order.edit"},
        component: () => import("./views/weight_notes/edit")
    },
    {
        path: "/sale_notes/:key/resume",
        name: "sale_notes.resume",
        meta: {authRequired: true, permission: "sale_reports.view"},
        component: () => import("./views/sale_notes/resume")
    },
    {
        path: "/sale_notes/:key/balancing",
        name: "sale_notes.balancing",
        meta: {authRequired: true},
        component: () => import("./views/sale_notes/balancing")
    },
    {
        path: "/services",
        name: "services.index",
        meta: {authRequired: true, permission: "beta_services.view"},
        component: () => import("./views/services")
    },
    {
        path: "/services/create",
        name: "services.create",
        meta: {authRequired: true, permission: "beta_services.create"},
        component: () => import("./views/services/create")
    },
    {
        path: "/services/:key",
        name: "services.show",
        meta: {authRequired: true, permission: "beta_services.view"},
        component: () => import("./views/services/show")
    },
    {
        path: "/services/:key/edit",
        name: "services.edit",
        meta: {authRequired: true, permission: "beta_services.edit"},
        component: () => import("./views/services/edit")
    },
    {
        path: "/balancings",
        name: "balancings.index",
        meta: {authRequired: true},
        component: () => import("./views/balancings")
    },
    {
        path: "/balancings/:key",
        name: "balancings.show",
        meta: {authRequired: true},
        component: () => import("./views/balancings/show")
    },
    {
        path: "/balancing_payments",
        name: "balancing_payments.index",
        meta: {authRequired: true},
        component: () => import("./views/balancing_payments")
    },
    {
        path: "/balancing_payments/create",
        name: "balancing_payments.create",
        meta: {authRequired: true},
        component: () => import("./views/balancing_payments/create")
    },
    {
        path: "/balancing_payments/:key",
        name: "balancing_payments.show",
        meta: {authRequired: true},
        component: () => import("./views/balancing_payments/show")
    },
    {
        path: "/odoo_account_payments/:key",
        name: "odoo_account_payments.show",
        meta: {authRequired: true, permission: "odoo_purchase_invoices.view"},
        component: () => import("./views/odoo_account_payments/show")
    },
    {
        path: "/odoo_account_payments",
        name: "odoo_account_payments.index",
        meta: {authRequired: true, permission: "odoo_purchase_invoices.view"},
        component: () => import("./views/odoo_account_payments")
    },
    {
        path: "/odoo_sale_invoices/:key",
        name: "odoo_sale_invoices.show",
        meta: {authRequired: true, permission: "odoo_sale_invoices.view"},
        component: () => import("./views/odoo_sale_invoices/show")
    },
    {
        path: "/odoo_sale_invoices",
        name: "odoo_sale_invoices.index",
        meta: {authRequired: true, permission: "odoo_sale_invoices.view"},
        component: () => import("./views/odoo_sale_invoices")
    },
    {
        path: "/manufactures",
        name: "manufactures.index",
        meta: {authRequired: true, permission: "hatcheries.view"},
        component: () => import("./views/manufactures"),
    },
    {
        path: "/manufactures/:key",
        name: "manufactures.show",
        meta: {authRequired: true, permission: "hatcheries.view"},
        component: () => import("./views/manufactures/show"),
    },
    {
        path: "/feeds",
        name: "feeds.index",
        meta: {authRequired: true, permission: "feed_products.view"},
        component: () => import("./views/feeds"),
    },
    {
        path: "/feeds/:key",
        name: "feeds.show",
        meta: {authRequired: true, permission: "feed_products.view"},
        component: () => import("./views/feeds/show"),
    },
    {
        path: "/users",
        name: "users.index",
        meta: {authRequired: true, permission: "users.view"},
        component: () => import("./views/users")
    },
    {
        path: "/users/create",
        name: "users.create",
        meta: {authRequired: true, permission: "users.create"},
        component: () => import("./views/users/create")
    },
    {
        path: "/users/:key",
        name: "users.show",
        meta: {authRequired: true, permission: "users.view"},
        component: () => import("./views/users/show")
    },
    {
        path: "/users/:key/edit",
        name: "users.edit",
        meta: {authRequired: true, permission: "users.edit"},
        component: () => import("./views/users/edit")
    },
    {
        path: "/approval_templates",
        name: "approval_templates.index",
        meta: {authRequired: true, permission: "approval_rules.view"},
        component: () => import("./views/approval_templates")
    },
    {
        path: "/approval_templates/create",
        name: "approval_templates.create",
        meta: {authRequired: true, permission: "approval_rules.create"},
        component: () => import("./views/approval_templates/create")
    },
    {
        path: "/approval_templates/:key",
        name: "approval_templates.show",
        meta: {authRequired: true, permission: "approval_rules.view"},
        component: () => import("./views/approval_templates/show")
    },
    // {
    //   path: "/playground/file",
    //   name: "playground.file",
    //   meta: { authRequired: true },
    //   component: () => import("./views/playground/file")
    // }
];
